import type { Router } from 'vue-router';
import {
  BaoCaoPdfParams,
  serializeBaoCaoPdfParams,
} from '@/core/helpers/bao-cao-pdf-params';

/**
 * Opens a báo cáo PDF viewer page in a new browser tab.
 */
export function openBaoCaoPdf(router: Router, params: BaoCaoPdfParams): void {
  const route = router.resolve({
    name: 'xem-bao-cao',
    params: { reportType: params.reportType },
    query: serializeBaoCaoPdfParams(params),
  });

  window.open(route.href, '_blank');
}
